import { useState } from 'react'

import { useQuery } from 'providers/tanstack-query/useQuery'
import { GET_FINANCE_REPORT } from './api'
import { fromDTO } from './api/mapper'
import { Data, Variables } from './api/types'
import { FinanceReport, UseGetFinanceReport, UseGetFinanceReportProps } from './types'

export const useGetFinanceReport = ({
  workspaceId,
}: UseGetFinanceReportProps): UseGetFinanceReport => {
  const [financeReport, setFinanceReport] = useState<FinanceReport>()

  const { isLoading: loading } = useQuery<Variables, Data>({
    onCompleted: async (data: Data) => {
      const { node: workspace } = data

      if (workspace) {
        setFinanceReport(fromDTO(workspace))
      }
    },
    options: {
      enabled: workspaceId !== undefined,
    },
    query: GET_FINANCE_REPORT,
    variables: { id: workspaceId },
  })

  return {
    financeReport,
    loading,
  }
}
